import { defineStore } from "pinia";
import { reactive } from "vue";
import type { SearchRequest } from "@/types/search/SearchRequest";

export interface FilterEntry {
	filters: Partial<SearchRequest>;
	filtersVisible: boolean;
}

const MAX_ENTRIES = 20;

export const useFiltersStore = defineStore("filters", () => {
	const entries = reactive(new Map<string, FilterEntry>());

	function setFilters(pageKey: string, filters: Partial<SearchRequest>, filtersVisible?: boolean): void {
		const existing = entries.get(pageKey);

		entries.set(pageKey, {
			filters,
			filtersVisible: filtersVisible ?? existing?.filtersVisible ?? false
		});

		if (entries.size > MAX_ENTRIES) {
			const oldestKey = entries.keys().next().value!;
			entries.delete(oldestKey);
		}
	}

	function getFilters(pageKey: string): FilterEntry | undefined {
		return entries.get(pageKey);
	}

	function clearFilters(pageKey: string): void {
		entries.delete(pageKey);
	}

	function setFiltersVisible(pageKey: string, visible: boolean): void {
		const existing = entries.get(pageKey);

		if (existing) {
			existing.filtersVisible = visible;
		} else {
			entries.set(pageKey, { filters: {}, filtersVisible: visible });
		}
	}

	return {
		entries,
		setFilters,
		getFilters,
		clearFilters,
		setFiltersVisible
	};
});
